// extracted by mini-css-extract-plugin
module.exports = {"imgWrapper":"DuotoneImage-module--imgWrapper--1HYQa","foreground":"DuotoneImage-module--foreground--CQ0uu"};